module.exports = __webpack_public_path__ + "img/green_015.b15a2c5c.png";